import type { MaybeRef } from 'vue';

export const frameQueryKey = 'frame';
export const getFrameQueryKey = (url: MaybeRef<string | undefined>) => [
  frameQueryKey,
  'get-frame',
  url,
];
